"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendar = exports.DateInput = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const utils_1 = require("@obvio/utils");
const react_1 = require("react");
const styled_1 = require("./DateInput/styled");
const utils_2 = require("./utils");
const aria_1 = require("./utils/aria");
const components_1 = require("./utils/InputElement/components");
const Dropdown_1 = require("../../Dropdown");
const DateInputElem = (0, react_1.forwardRef)((_a, ref) => {
    var { hasError, success, value = new Date(), label, onFocus: _onFocus, onBlur: _onBlur, onChange, className, calendarProps, dropdownProps, suffix, prefix, optional = false } = _a, props = __rest(_a, ["hasError", "success", "value", "label", "onFocus", "onBlur", "onChange", "className", "calendarProps", "dropdownProps", "suffix", "prefix", "optional"]);
    const [focus, setFocus] = (0, react_1.useState)(false);
    const id = (0, app_1.useCuid)();
    const disabled = Boolean(props.disabled);
    return ((0, jsx_runtime_1.jsx)(Dropdown_1.Dropdown, Object.assign({ render: ({ close }) => ((0, jsx_runtime_1.jsx)(styled_1.StyledCalendar, Object.assign({ value: value, onChange: (newValue) => {
                onChange(newValue);
                close();
            }, navigationLabel: ({ date, locale }) => {
                const formatter = new Intl.DateTimeFormat(locale, {
                    month: 'long',
                    year: 'numeric',
                });
                return formatter.format(date);
            }, formatShortWeekday: (locale, date) => {
                const format = new Intl.DateTimeFormat(locale, {
                    weekday: 'short',
                });
                return format.format(date)[0];
            }, next2Label: null, prev2Label: null }, calendarProps))) }, dropdownProps, { onOpen: () => {
            var _a;
            setFocus(true);
            (_a = dropdownProps === null || dropdownProps === void 0 ? void 0 : dropdownProps.onOpen) === null || _a === void 0 ? void 0 : _a.call(dropdownProps);
        }, onClose: () => {
            var _a;
            setFocus(false);
            (_a = dropdownProps === null || dropdownProps === void 0 ? void 0 : dropdownProps.onClose) === null || _a === void 0 ? void 0 : _a.call(dropdownProps);
        } }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [!!label && ((0, jsx_runtime_1.jsx)(utils_2.Label, Object.assign({ htmlFor: id, inputKind: "text", optional: optional, className: (0, utils_1.cls)({
                        'with-value': Boolean(value),
                    }) }, (0, aria_1.aria)({ invalid: hasError, success, disabled }), { children: label }))), (0, jsx_runtime_1.jsx)(styled_1.Wrapper, Object.assign({}, (0, aria_1.aria)({ invalid: hasError, success, disabled }), { className: (0, utils_1.cls)({
                        'focus-visible': focus,
                    }, className), suffix: suffix, prefix: prefix }, { children: (0, jsx_runtime_1.jsx)(components_1.InputInner, Object.assign({}, props, { ref: ref, id: id, readOnly: true, value: value ? value === null || value === void 0 ? void 0 : value.toDateString() : '' }, (0, aria_1.aria)({ invalid: hasError, success, disabled }))) }))] }) })));
});
exports.DateInput = (0, react_1.forwardRef)((_a, ref) => {
    var { defaultValue } = _a, props = __rest(_a, ["defaultValue"]);
    return ((0, jsx_runtime_1.jsx)(utils_2.InputController, Object.assign({}, props, { ref: ref, render: DateInputElem, defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : new Date() })));
});
var styled_2 = require("./DateInput/styled");
Object.defineProperty(exports, "Calendar", { enumerable: true, get: function () { return styled_2.StyledCalendar; } });
